import { render, staticRenderFns } from "./page_rentals.vue?vue&type=template&id=5e075d3e&"
import script from "./page_rentals.vue?vue&type=script&lang=js&"
export * from "./page_rentals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports